import React from "react";
import { ScrollView } from "react-native";
import { DataTable } from "react-native-paper";
import { Field, OrderByItem } from "../../config/companies/config";
import { ValueDisplayTable } from "../ValueDisplayTable";

interface CollectionType {
  uniqIdNumber?: boolean;
  [key: string]: any;
}

interface DataItem {
  id: string | number;
  [key: string]: any;
}

interface TableClassicLayoutProps {
  permittedFields: Field[];
  orderBy?: OrderByItem[];
  sortOptions: Record<string, "ascending" | "descending">;
  handleSort: (fieldName: string) => void;
  paginatedData: DataItem[];
  fields: Field[];
  collection: CollectionType;
  getRowStyle: (item: DataItem, fields: Field[]) => any;
  navigateToDetailsScreen: (
    fields: Field[],
    data: DataItem,
    collection: CollectionType,
  ) => void;
  t: (key: string) => string;
}

const TableClassicLayout: React.FC<TableClassicLayoutProps> = ({
  permittedFields,
  orderBy,
  sortOptions,
  handleSort,
  paginatedData,
  fields,
  collection,
  getRowStyle,
  navigateToDetailsScreen,
  t,
}) => {
  return (
    <>
      <DataTable>
        <DataTable.Header>
          {permittedFields.map((field) => {
            const isSortable = !!orderBy?.some((o) => o.field === field.name);

            if (isSortable) {
              return (
                <DataTable.Title
                  key={field.label}
                  sortDirection={sortOptions[field.name]}
                  onPress={() => handleSort(field.name)}
                  style={{ flex: field.width || 1 }}
                >
                  {t(field.label)}
                </DataTable.Title>
              );
            }

            return (
              <DataTable.Title
                key={field.label}
                style={{ flex: field.width || 1 }}
              >
                {t(field.label)}
              </DataTable.Title>
            );
          })}
        </DataTable.Header>
      </DataTable>

      <ScrollView
        style={{ flex: 1 }}
        showsVerticalScrollIndicator={true}
        contentContainerStyle={{ flexGrow: 1 }}
      >
        <DataTable>
          {paginatedData.map((item: DataItem) => {
            const rowStyle = getRowStyle(item, fields);

            return (
              <DataTable.Row
                key={item.id}
                onPress={() =>
                  navigateToDetailsScreen(fields, item, collection)
                }
                style={rowStyle}
              >
                {permittedFields.map((field) => (
                  <ValueDisplayTable
                    key={field.name}
                    field={field}
                    value={item[field.name]}
                  />
                ))}
              </DataTable.Row>
            );
          })}
        </DataTable>
      </ScrollView>
    </>
  );
};

export default TableClassicLayout;
